<template>
    <headboard></headboard>
    <div class="container">pricing</div>
</template>
<script>
import header from "../components/header.vue"
export default {
    name: 'pricing-page',
    data: function () {
        return {
        }
    },
    components: {
        'headboard': header
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style></style>